import { DateTimeDisplay, Icons, ReactIcons } from "@kalyzee/escaet-ui";
import { useRefAutoUpdate } from "@kalyzee/kast-web-sdk/web-components";
import { useEffect, useMemo, useRef } from "react";
import { RoomsControlCard, RoomsControlCardRef } from "../../../components/pedagogy/RoomsControlCard";
import { appMessage } from "../../../helpers/message";
import { useMeetingConfigurator, useMultiMeetingAPI } from "../../../hooks/meeting";
import { useSettings } from "../../../hooks/settings";
import { useWrapperAppData } from "../../../store/session/hooks";
import { usePedagogyContext } from "./context";
import styles from "./overview.module.css";
import { usePedagogyNotifications } from "../../../hooks/pedagogy";

export const OverviewPedagogyPage = () => {
  const [settings] = useSettings();
  const settingsRef = useRefAutoUpdate(settings);
  const pedagogyCtx = usePedagogyContext();
  const pedagogyCtxRef = useRefAutoUpdate(pedagogyCtx);
  const multiMeetingAPI = useMultiMeetingAPI();
  const meetingContainersAPI = useMemo(() => multiMeetingAPI.all?.getContainers()?.map((c) => c.getAPI()) ?? [], [multiMeetingAPI]);
  const roomsControlCardRef = useRef<RoomsControlCardRef>(null);
  const wrapperAppData = useWrapperAppData();

  usePedagogyNotifications(meetingContainersAPI);

  useMeetingConfigurator(meetingContainersAPI, {
    ovenMediaSession: {
      reception: {
        options: () => ({
          audio: false,
          video: { mode: "subscription", delayToDisableStream: 5000 },
        }),
      },
    },
  });

  // ---------------------------------------------------------------------- //
  // ---------------------------   UTILS ----------------------------- //
  // ---------------------------------------------------------------------- //

  // ---------------------------------------------------------------------- //
  // ---------------------------   EFFECT ----------------------------- //
  // ---------------------------------------------------------------------- //

  useEffect(() => {
    const validator = pedagogyCtxRef.current?.addAudioValidator(() => false);
    return () => {
      validator?.flush();
    };
  }, []);

  // ---------------------------------------------------------------------- //
  // ---------------------------   RENDER ----------------------------- //
  // ---------------------------------------------------------------------- //

  return (
    <div className={styles.container}>
      <div className={styles.leftPanel}>
        <img src={Icons.PedagoLogoSamii} alt="logo" />
        <DateTimeDisplay />
        {wrapperAppData?.canClose ? (
          <ReactIcons.CloseIcon
            className={styles.close}
            onClick={() => {
              appMessage.postCloseApp();
            }}
            width={40}
            height={40}
          />
        ) : null}
      </div>
      <RoomsControlCard ref={roomsControlCardRef} className={styles.content} kind="preview" />
    </div>
  );
};
